export default "<div class=\"tc-version\">{{ version }}</div>\r\n";